import { BaseAPI } from '@/api/base.api'
import { Evaluation } from '@/models/evaluation'
import { AxiosObservable } from 'axios-observable/dist/axios-observable.interface'
import { map } from 'rxjs/operators'
import { responsePathAsArray } from 'graphql'


export class EvaluationAPI extends BaseAPI<Evaluation> {
  constructor() {
    super()
    this.apiUrl = `${this.apiUrl}/api/evaluations`
  }
}